import { observer } from 'mobx-react-lite'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { type FirmDashboardJobTableViewModel } from '@/features/jobs/dashboard/FirmDashboardJobTableViewModel'
import { FirmDashboardJobsViewer } from '@/features/jobs/dashboard/components/FirmDashboardJobsViewer'
import { FirmDashboardJobsTableContainer } from '@/features/jobs/dashboard/components/FirmDashboardJobsTable/FirmDashboardJobsTableContainer'
import { useHotkey } from '@/hooks/keyboard-hooks'

export interface FirmDashboardJobsViewerContainerProps {
  vm: FirmDashboardJobTableViewModel
}

export const FirmDashboardJobsViewerContainer = observer(
  function FirmDashboardJobsViewerContainer({
    vm,
  }: FirmDashboardJobsViewerContainerProps) {
    useHotkey(['Escape'], vm.searcher.searchText.clear)

    return (
      <FirmDashboardJobsViewer>
        {vm.fetch.match({
          pending: () => <ContentLoading />,
          rejected: (err) => <ContentError error={err} />,
          resolved: () => <FirmDashboardJobsTableContainer vm={vm} />,
        })}
      </FirmDashboardJobsViewer>
    )
  },
)
